import * as React from 'react';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery, Theme } from '@material-ui/core';
import { useTranslate, DashboardMenuItem, MenuItemLink, getResources } from 'react-admin';
import SubMenu from './SubMenu';
import _ from "lodash";
import FrameworkAppContext from "./FrameworkAppContext";
import { makeStyles } from "@material-ui/core";
import FrameworkAuthCheck from "./FrameworkAuthCheck";


const useStyles = makeStyles(theme => ({
        root: {
            borderLeft: '3px solid #fff',
        },
        active: {
            borderLeft: '3px solid ' + theme.palette.primary.main,
        },
}));


const BuildParentMenus = (props, open, dense, handleToggle, state)=> {

    console.log('Building menus');
    const classes = useStyles();
    const appResources = React.useContext(FrameworkAppContext);
    const permissions = appResources.permissions;

    var {onMenuClick, logout, appresources} = props;
    const translate = useTranslate();

    if (!appResources)
        throw 'no appresources';


    // First, do the authcheck on every menu item, remove items that do not pass
    const menus = filterAuthCheck(appResources.menuItems, permissions);

    const groupedMenus = _.groupBy(menus, 'parentMenu');
    const parentmenus = [];

    console.log('Menu structure', {groupedMenus})


    var self = this;
    _.forEach(groupedMenus, function(menuItems, parent) {
        const menus = [];
        var parentMenuIcon;

        _.forEach(menuItems, function(item) {
            menus.push((
                <MenuItemLink
                    classes={classes}
                    key={item.name}
                    id={item.name}
                    to={`/${item.route ? item.route : item.name}`}
                    primaryText={translate(`resources.${item.name}.name`, {
                        smart_count: 2,
                    })}
                    leftIcon={item.icon}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                    dense={dense}
                />
            ))
            if (item.parentMenuIcon)
                parentMenuIcon = item.parentMenuIcon;
        });

        const ParentMenuIcon = menuItems[0].parentMenuIcon;

        const parentmenu = (
            <SubMenu
                key={`resources.${parent}.name`}
                id={`resources.${parent}.name`}
                handleToggle={() => handleToggle(parent)}
                isOpen={state[parent]}
                sidebarIsOpen={open}
                name={`resources.${parent}.name`}
                icon={parentMenuIcon}
                dense={dense}
            >
                {menus}
            </SubMenu>
        );

        parentmenus.push(parentmenu);
        // if (menus.length > 1)
        //     parentmenus.push(parentmenu);
        // else
        //     parentmenus.push(menus);

    });

    return parentmenus;

}

const filterAuthCheck = (menus, permissions) => {

    const r = [];
    menus.forEach((menu)=> {
        if (!menu.menuAuth) {
            r.push(menu);
        }
        else {
            const required = menu.menuAuth;
            var passedAuth = FrameworkAuthCheck(menu, 'menuAuth', permissions);
            if (passedAuth)
                r.push(menu);
        }
    });

    return r;

}


const Menu = (props) => {

    const { onMenuClick, dense, logout } = props;
    const [state, setState] = useState({
        menuCatalog: false,
        menuSales: false,
        menuCustomers: false,
    });
    const translate = useTranslate();
    const isXSmall = useMediaQuery((theme) =>
        theme.breakpoints.down('xs')
    );
    const open = useSelector((state) => state.admin.ui.sidebarOpen);
    useSelector((state) => state.theme); // force rerender on theme change

    const handleToggle = (menu) => {
        setState(state => ({ ...state, [menu]: !state[menu] }));
    };

    const parentMenuItems = BuildParentMenus(props, open, dense, handleToggle, state);

    return (
        <div>
            {' '}
            <DashboardMenuItem onClick={onMenuClick} sidebarIsOpen={open} />
            {/*<SubMenu*/}
            {/*    handleToggle={() => handleToggle('setup')}*/}
            {/*    isOpen={state.setup}*/}
            {/*    sidebarIsOpen={open}*/}
            {/*    name="app.resources.setup"*/}
            {/*    icon={<AppIcon />}*/}
            {/*    dense={dense}*/}
            {/*>*/}
            {/*    <MenuItemLink*/}
            {/*        to={`/workstationSetup`}*/}
            {/*        primaryText={translate(`app.resources.workstationSetup`, {*/}
            {/*            smart_count: 2,*/}
            {/*        })}*/}
            {/*        onClick={onMenuClick}*/}
            {/*        sidebarIsOpen={open}*/}
            {/*        dense={dense}*/}
            {/*    />*/}
            {/*</SubMenu>*/}
            {parentMenuItems}
            {/*{logout}*/}
        </div>
    );
};

const mapStateToProps = state => ({
    resources: getResources(state),
});

const skipRenderIfLogOutChanged = (props, nextProps)=> {
    if(props.logout != nextProps.logout) {
        // don't re-render/update
        return true
    }
};

//export default withRouter(connect(mapStateToProps)(withStyles(styles)(React.memo(Menu))));
export default React.memo(Menu, skipRenderIfLogOutChanged);